const initState = {
  isLoaderGeneralApp: false,
  loaderValidar: false,
  loaderValidarTcco: false,
  loaderSesion: false,
  loaderInformar: false,
  loaderObtener: false,
  loaderTercerFactorSolicitar: false,
  loaderTercerFactorValidar: false
};

export default initState;
